import * as React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { InfoMessageTypeEnum } from '@websky/graphql';
import { useTheme } from '@websky/core/src/theme';
import { getCurrency } from '@websky/core/src/cache';
import { Currency } from '@websky/core/src/enums';
import Notification from '@websky/core/src/Notification';
import { getCurrencyFromOrder } from '../../../../../core/src/Checkout/store/order/selectors';

const PassengersNotifications: React.FC = () => {
	const { CheckoutStyles: css } = useTheme('Checkout');
	const { t } = useTranslation('Checkout');

	const currencyFromOrder = useSelector(getCurrencyFromOrder);

	if (getCurrency() !== Currency.KZT || currencyFromOrder === Currency.KZT) {
		return null;
	}

	return (
		<Notification
			className={css.messages_item}
			title={t('Attention')}
			status={InfoMessageTypeEnum.Info}
			infoMessage={{
				text: t('Write-off of funds is made in tenge'),
				type: InfoMessageTypeEnum.Info,
				code: 'payment-notice'
			}}
			type="context"
		/>
	);
};

export default PassengersNotifications;
